import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackCheckboxAllClick } from './tracking';
import { selectAll, unselectAll } from '../../actions/selected';
import { selectResults } from '../../selectors/results';
import { selectAllEntities, selectIsAllEntitiesSelected } from '../../selectors/selected';

export const CheckboxAllContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isChecked = useSelector(selectIsAllEntitiesSelected);
  const allIds = useSelector(selectAllEntities);
  const results = useSelector(selectResults);
  const { favoriteEntities } = results;

  const onChange = () => {
    trackCheckboxAllClick(favoriteEntities);

    return dispatch(isChecked ? unselectAll() : selectAll({ ids: allIds }));
  };

  return <Checkbox checked={isChecked} onChange={onChange} />;
};
